<dc-navbar-default
  [useOnlyDarkLogo]="true"
  [darkLinks]="true"
></dc-navbar-default>

<main class="position-relative overflow-hidden">
  <dc-social-heading></dc-social-heading>

  <dc-features-icons-col></dc-features-icons-col>
  <dc-big-screen
    [img]="'assets/img/screens/dash/1.png'"
    [screenPos]="'left'"
    [imgShape]="'assets/img/shps/abs-shp-3.svg'"
  >
    <h2>Designed to provide top-notch appearance</h2>

    <p class="lead text-secondary">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua.
    </p>

    <p>
      Nullam vitae scelerisque est, sed tempus metus. Donec convallis volutpat
      enim consequat viverra. Nam blandit est eu ipsum elementum, ac
      pellentesque nibh placerat. Quisque venenatis pulvinar nulla, non
      vestibulum urna ultrices accumsan.
    </p>

    <a href="#" class="btn btn-info btn-rounded mt-4">Learn More</a>
  </dc-big-screen>

  <dc-big-screen
    [img]="'assets/img/screens/dash/4.png'"
    [imgShape]="'assets/img/shps/abs-shp-1.svg'"
  >
    <h2>Analytics</h2>

    <p class="lead text-secondary">
      Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua.
    </p>

    <p>
      Nullam vitae scelerisque est, sed tempus metus. Donec convallis volutpat
      enim consequat viverra. Nam blandit est eu ipsum elementum, ac
      pellentesque nibh placerat. Quisque venenatis pulvinar nulla, non
      vestibulum urna ultrices accumsan.
    </p>
  </dc-big-screen>

  <dc-counter6></dc-counter6>
  <dc-social-register></dc-social-register>
  <dc-slider-tools4-success></dc-slider-tools4-success>
  <dc-social-services></dc-social-services>

  <dc-cta1 [background]="'contrast'" [edge]="'top-left'"></dc-cta1>

  <dc-footer1></dc-footer1>
</main>
